import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/AdminLayout';
import WysiwygEditor from '../../components/WysiwygEditor';
import api from '../../services/api';

function MechanicsEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [mechanic, setMechanic] = useState({
    label: '',
    description: ''
  });

  useEffect(() => {
    fetchMechanic();
  }, [id]);

  const fetchMechanic = async () => {
    try {
      const response = await api.get(`/admin/mechanics/${id}`);
      setMechanic(response.data.mechanic);
    } catch (err) {
      console.error('Failed to fetch mechanic:', err);
      alert('Failed to load mechanic');
      navigate('/admin/mechanics');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    if (!mechanic.label.trim()) {
      alert('Please provide a mechanic name');
      return;
    }

    setSaving(true);
    try {
      await api.put(`/admin/mechanics/${id}`, {
        label: mechanic.label,
        description: mechanic.description,
        type: mechanic.type || ''
      });
      navigate('/admin/mechanics');
    } catch (err) {
      console.error('Failed to save mechanic:', err);
      alert('Failed to save mechanic');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <AdminLayout activeSection="MECHANICS">
        <div className="flex items-center justify-center h-64">
          <div className="text-white">Loading...</div>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout activeSection="MECHANICS">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-white">Edit Mechanic Type</h1>
        <button
          onClick={() => navigate('/admin/mechanics')}
          className="px-6 py-3 bg-gray-600 text-white rounded-xl hover:bg-gray-700 font-medium"
        >
          Back to List
        </button>
      </div>

      <div className="bg-white rounded-3xl shadow-2xl p-8">
        <div className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Mechanic Name *
            </label>
            <input
              type="text"
              value={mechanic.label}
              onChange={(e) => setMechanic({ ...mechanic, label: e.target.value })}
              placeholder="e.g., Weekend Bonus Entries"
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Type / Category *
            </label>
            <select
              value={mechanic.type || ''}
              onChange={(e) => setMechanic({ ...mechanic, type: e.target.value })}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent"
            >
              <option value="">Select a type...</option>
              <option value="membership">Membership</option>
              <option value="cashback">Cashback</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Description
            </label>
            <WysiwygEditor
              value={mechanic.description || ''}
              onChange={(value) => setMechanic({ ...mechanic, description: value })}
              placeholder="Describe how this mechanic works, including rules, win conditions, and prize structure..."
            />
          </div>
        </div>

        <div className="flex justify-end gap-4 mt-8">
          <button
            type="button"
            onClick={() => navigate('/admin/mechanics')}
            className="px-6 py-3 text-gray-700 bg-gray-200 rounded-xl hover:bg-gray-300 font-medium"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSave}
            disabled={saving}
            className={`px-6 py-3 bg-teal-600 text-white rounded-xl hover:bg-teal-700 font-medium ${
              saving ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            {saving ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>
    </AdminLayout>
  );
}

export default MechanicsEdit;